<template>
	<div
		id="paypal-button-container"
		:class="{'paypal-disabled': loading}"
	/>
</template>
<script>
export default {
	name: 'PaymentPaypal',
	props: {
		amount: {
			type: Number
		},
		currency: {
			type: String
		},
		formValid: {
			type: Boolean
		},
		clientId: {
			type: String
		}
	},
	data () {
		return {
			loading: false
		}
	},
	methods: {
		initPayPalButton () {
			window.paypal.Buttons({
				style: {
					shape: 'rect',
					color: 'gold',
					label: 'paypal'

				},
				funding: {
					disallowed: [paypal.FUNDING.CREDIT]
				},
				createOrder: (data, actions) => {
					// https://developer.paypal.com/sdk/js/reference/#createorder
					const amount = (Math.round((this.amount) * 100) / 100).toFixed(2)
					return actions.order.create({
						// intent: 'AUTHORIZE',
						purchase_units: [{
							amount: {
								currency_code: this.currency,
								value: amount
							}
						}]
					})
				},
				onClick: async (data, actions) => {
					await this.$emit('validate')
					if (!this.formValid) {
						return actions.reject()
					} else if (!this.loading) {
						this.loading = true
						return actions.resolve()
					}
				},

				onApprove: (data, actions) => {
					this.processPayment(data)
				},

				onError: (err) => {
					this.loading = false
					console.log(err)
				}
			}).render('#paypal-button-container')
		},
		async processPayment (data) {
			await this.$emit('process', { paypal: data })
		}
	},
	mounted() {
		const script = document.createElement('script')
		script.src = `https://www.paypal.com/sdk/js?client-id=${this.clientId}&currency=${this.currency}&disable-funding=credit,card`
		document.body.appendChild(script)
		script.addEventListener('load', () => this.initPayPalButton())
	}
}
</script>
<style>
.paypal-disabled {
	opacity: 0.6;
	cursor: not-allowed;
	pointer-events: none;
}
</style>
